<!-- PACED -Start -->
<div class="linking__group--fixed">


  <a class="link link__P linkAnimate" [routerLink]="['/paced']">
    <div class="circle circle__All">
      <h2 class="all">All</h2>
    </div>
    <div class="side side__All">
      <p>All content</p>
    </div>
  </a>

  <a class="link link__P linkAnimate" [routerLink]="['/paced','p']">
    <div class="circle circle__P">
      <h2>P</h2>
    </div>
    <div class="side side__P">
      <p>Purpose Learning</p>
    </div>
  </a>

  <a class="link link__A linkAnimate" [routerLink]="['/paced','a']">
    <div class="circle circle__A">
      <h2>A</h2>
    </div>
    <div class="side side__A">
      <p>Active Learning</p>
    </div>
  </a>

  <a class="link link__C linkAnimate" [routerLink]="['/paced','c']">
    <div class="circle circle__C">
      <h2>C</h2>
    </div>
    <div class="side side__C">
      <p>Competence Learning</p>
    </div>
  </a>

  <a class="link link__E linkAnimate" [routerLink]="['/paced','e']">
    <div class="circle circle__E">
      <h2>E</h2>
    </div>
    <div class="side side__E">
      <p>Enterprise Collaboration</p>
    </div>
  </a>

  <a class="link link__D linkAnimate" [routerLink]="['/paced','d']">
    <div class="circle circle__D">
      <h2>D</h2>
    </div>
    <div class="side side__D">
      <p>Diversity</p>
    </div>
  </a>

</div>
<!-- PAECD -End -->
